import { AbstractControl, FormControl, FormGroup, FormArray } from '@angular/forms';

/* eslint-disable @typescript-eslint/no-explicit-any */
export const markAsTouchedDeep = (control: AbstractControl) => {
  const isFormControl = control instanceof FormControl;
  const isFormGroup = control instanceof FormGroup;
  const isFormArray = control instanceof FormArray;

  if (isFormControl || isFormGroup) {
    control.markAsTouched();
    // control.markAsDirty();
    // control.updateValueAndValidity();
  }

  // handle child controls
  if (control.hasOwnProperty('controls')) {
    const { controls } = control as any;

    if (isFormGroup) {
      for (const k in controls) {
        if (k in controls) {
          const c = controls[k];
          markAsTouchedDeep(c);
        }
      }
    }

    if (isFormArray) {
      for (const c of controls) {
        markAsTouchedDeep(c);
      }
    }
  }
};
